import { combineReducers } from 'redux';
import axios from 'axios';
import _ from 'lodash';
import * as Urls from 'src/constants/EndpointUrls';
import createNamedWrapperReducer from 'src/reducers/createNamedWrapperReducer';
import { listReducer, itemReducer } from 'src/reducers/common';
import { fetchList, fetchListSuccess, fetchListFailure, setExtras } from 'src/reducers/common/listReducer';
import { setItemExtra, getItemExtra } from 'src/reducers/common/itemReducer';
import { serializeHttpGetParams, redirectTo } from 'src/utils/Http';
import { takePaysSearchQueries } from 'src/reducers/searchForm';

export const REDUCER_NAME = 'yearEndReportPndKors';
export const getDownloadPndKorOnlineErrors = state => getItemExtra(REDUCER_NAME, state).pndKorErrors;
export const setDownloadPndKorOnlineData = pndKorErrors => setItemExtra(REDUCER_NAME, { pndKorErrors });
export const clearDownloadPndKorOnlineData = () => setItemExtra(REDUCER_NAME, { pndKorErrors: '' });

export const fetchYearEndReportPndKors = (formValues, isFetchGrouped) => async dispatch => {
  try {
    dispatch(fetchList(REDUCER_NAME));
    let params = null;
    if (isFetchGrouped) {
      params = { year: formValues.groupedPaymentYears, client_branch_id: formValues.offices };
    } else {
      params = takePaysSearchQueries(formValues);
    }

    const fetchUrl = `${Urls.SEARCH_PND_KOR_DATA}?${serializeHttpGetParams(params)}`;
    const response = await axios.get(fetchUrl);
    const employeePays = response.data.payload.employeePays;
    const payload = { data: employeePays, pageCount: 0 };
    const { 
      totalEmployees,
      totalIncomes, 
      totalSpecialRateIncomes,
      totalSeverancePay,
      totalWorkInsideThaiIncomes,
      totalWorkOutsideThaiIncomes,
      totalWithholdingTaxes, 
    } = response.data.payload;
    dispatch(fetchListSuccess(REDUCER_NAME, payload));
    dispatch(setExtras(REDUCER_NAME, { 
      totalEmployees,
      totalIncomes, 
      totalSpecialRateIncomes,
      totalSeverancePay,
      totalWorkInsideThaiIncomes,
      totalWorkOutsideThaiIncomes,
      totalWithholdingTaxes, 
    }))
  } catch (exception) {
    dispatch(fetchListFailure(REDUCER_NAME, exception.response.data.errors.messages));
  }
}

export const downloadPndKorOnline = (data, formValues) => async dispatch => {
  try {
    dispatch(clearDownloadPndKorOnlineData());
    const params = { format_type: data.format_type, client_branch_id: formValues.offices, year: formValues.groupedPaymentYears };
    const url = `${Urls.DOWNLOAD_PND_KOR_ONLINE_DATA}?${serializeHttpGetParams(params)}`;
    await axios.get(url);
    redirectTo(url);
  } catch (exception) {
    const errors = _.get(exception, ['response', 'data', 'errors', 'messages']) || [exception.message];
    dispatch(setDownloadPndKorOnlineData(errors));
  }
};

export default combineReducers({
  list: createNamedWrapperReducer(listReducer, REDUCER_NAME),
  item: createNamedWrapperReducer(itemReducer, REDUCER_NAME)
});
